import React from 'react';
import {
  TimelineView,
  TimelineItem,
  TimelineHeader,
  TimelineIcon,
  TimelineTitle,
  TimelineBody,
} from '@sketchpixy/rubix';

const timelineView = (props) => {
  return (
      <TimelineView withHeader className={`border-hover${props.color} tl-${props.color}`}>
        <TimelineItem>
          <TimelineHeader className={`bg-hover${props.color}`}>
            <TimelineIcon className={`bg-${props.color} fg-white`} glyph='icon-fontello-chat-1' />
            <TimelineTitle>
              {props.title}
            </TimelineTitle>
          </TimelineHeader>
          <TimelineBody>
            <ul>
              <li>
                {props.des}
              </li>
            </ul>
          </TimelineBody>
        </TimelineItem>
      </TimelineView>
  );
};

export default timelineView;



// WEBPACK FOOTER //
// ./src/common/TimelineView.js